import { Filter } from '@pixi/core';
import vertex from './fxaa.mjs';
import fragment from './fxaa2.mjs';

class FXAAFilter extends Filter {
  constructor() {
    super(vertex, fragment);
  }
}

export { FXAAFilter };
//# sourceMappingURL=FXAAFilter.mjs.map
